module.exports = __webpack_public_path__ + "static/media/14_l_stalinka_0_1.76.45189a24.png";